<template>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="应用名称">
        <el-input v-model="searchForm.appName" placeholder="请输入应用名称"></el-input>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" @click="search()">搜索</el-button>
          <el-button type="primary" @click="showAdd()">新建</el-button>
      </el-form-item>
    </el-form>
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="应用ID" width="100">
        <template #default="scope">
          <div>
            <span>{{ scope.row.id }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="应用名称" width="180" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.appName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="应用Key" width="300" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.appKey }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="应用密钥" width="300" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.appSecret }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="scope">
          <div>
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="过期时间" width="180">
        <template #default="scope">
          <div>
            <span>{{ scope.row.expireTime || '永不过期' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="备注" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.remark || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="350" fixed="right">
        <template #default="scope">
          <el-button size="small" @click="handleView(scope.$index, scope.row)">
            查看
          </el-button>
          <el-button size="small" type="primary" @click="handleApiPermission(scope.$index, scope.row)">
            API授权
          </el-button>
          <el-button size="small" type="success" @click="handleStationPermission(scope.$index, scope.row)">
            场站授权
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 对话框--新建 -->
    <el-dialog v-model="dialogFormVisible" title="新建应用" width="500" :close-on-click-modal="false" @closed="$refs.addFormRef?.clearValidate()">
        <el-form ref="addFormRef" :model="addInfo" :rules="addRules" label-position="right" label-width="auto">
        <el-form-item label="应用名称" prop="appName">
            <el-input v-model="addInfo.appName" autocomplete="off" placeholder="请输入应用名称" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="addInfo.remark"
            :autosize="{ minRows: 3, maxRows: 6 }"
            type="textarea"
            maxlength="500"
            placeholder="请输入备注"
          />
        </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="save()">确定</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--查看详情 -->
    <el-dialog v-model="viewDialogVisible" title="应用详情" width="600" :close-on-click-modal="false">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="应用ID">{{ viewInfo.appId }}</el-descriptions-item>
          <el-descriptions-item label="应用名称">{{ viewInfo.appName }}</el-descriptions-item>
          <el-descriptions-item label="应用Key">{{ viewInfo.appKey }}</el-descriptions-item>
          <el-descriptions-item label="应用密钥">{{ viewInfo.appSecret }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="viewInfo.status === 1 ? 'success' : 'danger'">
              {{ viewInfo.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="过期时间">{{ viewInfo.expireTime || '永不过期' }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ viewInfo.remark || '--' }}</el-descriptions-item>
        </el-descriptions>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="viewDialogVisible = false">关闭</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--删除 -->
    <el-dialog
      v-model="centerDialogVisible"
      title="提示"
      width="500"
      align-center
    >
      <span>确定删除该应用？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteApp()">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 对话框--API授权管理 -->
    <el-dialog v-model="apiPermissionDialogVisible" title="API授权管理" width="1100" :close-on-click-modal="false">
      <div class="api-permission-header">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="接口名称">
            <el-input v-model="apiSearchForm.apiName" placeholder="请输入接口名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchApiList()">搜索</el-button>
            <el-button @click="resetApiSearch()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <div class="api-permission-actions">
        <el-button type="primary" @click="batchAuthorize()" :disabled="selectedApiIds.length === 0">
          批量授权
        </el-button>
        <span class="selected-count" v-if="selectedApiIds.length > 0">
          已选择 {{ selectedApiIds.length }} 项
        </span>
      </div>

      <el-table 
        ref="apiTableRef"
        class="table_wrapper" 
        :data="apiTableData" 
        :header-cell-style="{'text-align':'center'}" 
        :cell-style="{'text-align':'center'}"
        @selection-change="handleApiSelectionChange"
        row-key="permissionCode"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="接口名称" prop="apiName" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="接口URI" prop="apiUri" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="请求方法" prop="method" width="100">
          <template #default="scope">
            <el-tag :type="getMethodType(scope.row.method)" size="small">
              {{ scope.row.method }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="权限编码" prop="permissionCode" width="150"></el-table-column>
        <el-table-column label="接口描述" prop="description" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="80">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!-- API资源分页 -->
      <Pagination
        v-model:current-page="apiCurrentPage"
        v-model:page-size="apiPageSize"
        :total="apiTotal"
        @size-change="handleApiSizeChange"
        @current-change="handleApiCurrentChange"
      />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="apiPermissionDialogVisible = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 对话框--场站授权管理 -->
    <el-dialog v-model="stationPermissionDialogVisible" title="场站授权管理" width="1100" :close-on-click-modal="false">
      <div class="api-permission-header">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="场站名称">
            <el-input v-model="stationSearchForm.name" placeholder="请输入场站名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchStationList()">搜索</el-button>
            <el-button @click="resetStationSearch()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <div class="api-permission-actions">
        <el-button type="primary" @click="batchAuthorizeStation()" :disabled="selectedStationIds.length === 0">
          批量授权
        </el-button>
        <span class="selected-count" v-if="selectedStationIds.length > 0">
          已选择 {{ selectedStationIds.length }} 项
        </span>
      </div>

      <el-table 
        ref="stationTableRef"
        class="table_wrapper" 
        :data="stationTableData" 
        :header-cell-style="{'text-align':'center'}" 
        :cell-style="{'text-align':'center'}"
        @selection-change="handleStationSelectionChange"
        row-key="stationId"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="场站ID" prop="stationId" width="100"></el-table-column>
        <el-table-column label="场站名称" prop="stationName" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="详细地址" prop="address" min-width="300" show-overflow-tooltip></el-table-column>
      </el-table>

      <!-- 场站资源分页 -->
      <Pagination
        v-model:current-page="stationCurrentPage"
        v-model:page-size="stationPageSize"
        :total="stationTotal"
        @size-change="handleStationSizeChange"
        @current-change="handleStationCurrentChange"
      />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="stationPermissionDialogVisible = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>

  </template>
  
  <script>
  import { ElMessage } from 'element-plus';
  import { required } from '@/utils/validators';
  export default {
  name:'ThirdAppManagement',
  data() {
    return {
      searchForm:{
        appName:'',
      },
        centerDialogVisible:false,
        viewDialogVisible:false,
        currt_id:'', //当前操作id
        dialogFormVisible:false,
        tableData:[],
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
        addFormRef: null,
        addRules: {
          appName: [required('请输入应用名称')],
        },
        addInfo:{
            appId:'',
            appName: '',
            remark:'',
        },
        viewInfo:{
            appId:'',
            appName:'',
            appKey:'',
            appSecret:'',
            status:1,
            expireTime:'',
            remark:'',
        },
        apiPermissionDialogVisible:false,
        apiTableData:[],
        apiTotal: 0,
        apiCurrentPage: 1,
        apiPageSize: 10,
        apiSearchForm:{
          apiName:'',
        },
        selectedApiIds:[],
        currentAppId:'',
        stationPermissionDialogVisible:false,
        stationTableData:[],
        stationTotal: 0,
        stationCurrentPage: 1,
        stationPageSize: 10,
        stationSearchForm:{
          name:'',
        },
        selectedStationIds:[],
    }
  },
  created(){
    
  },
  mounted(){
    this.getList();
  },
  methods:{
    //搜索
    search(){
      this.currentPage = 1;
      this.getList();
    },
    handleSizeChange (val) { //每页显示条数
        this.pageSize = val;
        this.currentPage = 1;
        this.getList();
    },
    handleCurrentChange(val) { //当前页
        this.currentPage = val;
        this.getList(); //获取列表
    },
    getList(){
      //获取应用列表
      let that = this;
      let param = {};
      param.page = that.currentPage;
      param.pageSize = that.pageSize;
      param.appName = that.searchForm.appName;
      that.$axios.post("open-server/openapi/admin/apps/page",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.tableData = result.data.records;
          that.total = result.data.total; //总条数
        }
      })
    },
    save(){
      //保存
      let that = this;
      // 表单校验
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return;
        //新增（注册）
        var url = "open-server/openapi/admin/apps";
        that.$axios.post(url,JSON.stringify(that.addInfo)).then(result => {
          if(result.code==200){
            // 保存成功
            that.dialogFormVisible = false;
            that.getList();
            ElMessage({
              message: '保存成功',
              type: 'success',
            })
          }
        })
      });
    },
    showAdd(){
      //打开新建
        this.addInfo = {
            appId:'',
            appName: '',
            remark:'',
        };
        this.dialogFormVisible = true;
    },
    handleView(index,row){
      //查看详情 - 打开新tab
      let tabPath = '/thirdappmanagement/detail/' + row.appKey;

      this.$store.commit('addHeaderTabs', {
        topic: row.appName + ' - 详情',
        path: tabPath
      });
      this.$router.push(tabPath);
    },
    deleteApp(){
      //删除应用
      let that = this;
      that.$axios.post("open-server/openapi/admin/apps/del/"+that.currt_id).then(result => {
        if(result.code==200){
          that.centerDialogVisible = false;
          that.getList();
          ElMessage({
            message: '已删除应用',
            type: 'success',
          })
        }
      })
    },
    handleDelete(index,row){
      //删除弹窗
      this.centerDialogVisible = true;
      this.currt_id = row.id;
    },
    handleApiPermission(index,row){
      //打开API授权管理
      this.currentAppId = row.id;
      this.apiPermissionDialogVisible = true;
      this.apiCurrentPage = 1;
      this.apiSearchForm.apiName = '';
      this.selectedApiIds = [];
      this.getApiList();
    },
    getApiList(){
      //获取API资源列表
      let that = this;
      let param = {};
      param.current = that.apiCurrentPage;
      param.size = that.apiPageSize;
      param.apiName = that.apiSearchForm.apiName;
      param.appId = that.currentAppId;
      that.$axios.post("open-server/openapi/api/notAuthPageByAppId",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.apiTableData = result.data.records;
          that.apiTotal = result.data.total;
          // 恢复选中状态
          that.$nextTick(() => {
            if(that.$refs.apiTableRef){
              that.apiTableData.forEach(row => {
                if(that.selectedApiIds.includes(row.permissionCode)){
                  that.$refs.apiTableRef.toggleRowSelection(row, true);
                }
              });
            }
          });
        }
      })
    },
    searchApiList(){
      //搜索API资源
      this.apiCurrentPage = 1;
      this.getApiList();
    },
    resetApiSearch(){
      //重置API搜索
      this.apiSearchForm.apiName = '';
      this.apiCurrentPage = 1;
      this.getApiList();
    },
    handleApiSizeChange(val){
      //API每页显示条数
      this.apiPageSize = val;
      this.apiCurrentPage = 1;
      this.getApiList();
    },
    handleApiCurrentChange(val){
      //API当前页
      this.apiCurrentPage = val;
      this.getApiList();
    },
    handleApiSelectionChange(selection){
      //API选择变化
      this.selectedApiIds = selection.map(item => item.id);
    },
    getMethodType(method){
      //获取请求方法类型对应的tag颜色
      const typeMap = {
        'GET': '',
        'POST': 'success',
        'PUT': 'warning',
        'DELETE': 'danger'
      };
      return typeMap[method] || '';
    },
    batchAuthorize(){
      //批量授权
      let that = this;
      if(that.selectedApiIds.length === 0){
        ElMessage({
          message: '请选择要授权的API',
          type: 'warning',
        });
        return;
      }
      let param = {
        appId: that.currentAppId,
        apiIds: that.selectedApiIds
      };
      that.$axios.post("open-server/openapi/admin/apps/apiPermissions",JSON.stringify(param)).then(result => {
        if(result.code==200){
          ElMessage({
            message: '授权成功',
            type: 'success',
          });
          that.selectedApiIds = [];
          that.$refs.apiTableRef.clearSelection();
          that.getApiList();
        }
      })
    },
    handleStationPermission(index,row){
      //打开场站授权管理
      this.currentAppId = row.id;
      this.stationPermissionDialogVisible = true;
      this.stationCurrentPage = 1;
      this.stationSearchForm.name = '';
      this.selectedStationIds = [];
      this.getStationList();
    },
    getStationList(){
      //获取场站资源列表
      let that = this;
      let param = {};
      param.page = that.stationCurrentPage;
      param.pageSize = that.stationPageSize;
      param.stationName = that.stationSearchForm.name;
      param.appId = that.currentAppId;
      that.$axios.post("open-server/openapi/station/notAuthListByAppId",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.stationTableData = result.data.records;
          that.stationTotal = result.data.total;
          // 恢复选中状态
          that.$nextTick(() => {
            if(that.$refs.stationTableRef){
              that.stationTableData.forEach(row => {
                if(that.selectedStationIds.includes(row.stationId)){
                  that.$refs.stationTableRef.toggleRowSelection(row, true);
                }
              });
            }
          });
        }
      })
    },
    searchStationList(){
      //搜索场站资源
      this.stationCurrentPage = 1;
      this.getStationList();
    },
    resetStationSearch(){
      //重置场站搜索
      this.stationSearchForm.name = '';
      this.stationCurrentPage = 1;
      this.getStationList();
    },
    handleStationSizeChange(val){
      //场站每页显示条数
      this.stationPageSize = val;
      this.stationCurrentPage = 1;
      this.getStationList();
    },
    handleStationCurrentChange(val){
      //场站当前页
      this.stationCurrentPage = val;
      this.getStationList();
    },
    handleStationSelectionChange(selection){
      //场站选择变化
      this.selectedStationIds = selection.map(item => item.stationId);
    },
    batchAuthorizeStation(){
      //批量授权场站
      let that = this;
      if(that.selectedStationIds.length === 0){
        ElMessage({
          message: '请选择要授权的场站',
          type: 'warning',
        });
        return;
      }
      let param = {
        appId: that.currentAppId,
        stationIds: that.selectedStationIds
      };
      that.$axios.post("open-server/openapi/admin/apps/stationPermissions",JSON.stringify(param)).then(result => {
        if(result.code==200){
          ElMessage({
            message: '授权成功',
            type: 'success',
          });
          that.selectedStationIds = [];
          that.$refs.stationTableRef.clearSelection();
          that.getStationList();
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
.api-permission-header{
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}
.api-permission-actions{
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  .selected-count{
    color: #409eff;
    font-size: 14px;
  }
}
</style>